<template>
  <div>
    <v-data-table
      v-model="selected"
      :items="items"
      :headers="filteredHeaders"
      :loading="isLoading"
      item-key="family_edition_id"
      hide-actions
      select-all
      :headers-length="filteredHeaders.length + 2"
    >
      <template
        slot="headers"
        slot-scope="props"
      >
        <tr>
          <th class="pa-0" />
          <template v-for="header in props.headers">
            <th
              v-if="!header.desktopOnly && !desktopOnly"
              :key="header.text"
              class="text-xs-left px-1"
            >
              {{ header.text }}
              <a @click="sorting(header)">
                <BaseIcon
                  v-if="header.icon"
                  width="16px"
                  height="13px"
                >
                  <component :is="header.icon" />
                </BaseIcon>
              </a>
            </th>
            <th
              v-if="desktopOnly"
              :key="header.text"
              class="text-xs-left"
            >
              {{ header.text }}
              <a @click="sorting(header)">
                <BaseIcon
                  v-if="header.icon"
                  width="16px"
                  height="13px"
                >
                  <component :is="header.icon" />
                </BaseIcon>
              </a>
            </th>
          </template>
        </tr>
      </template>
      <template
        slot="items"
        slot-scope="props"
      >
        <tr
          @click="showCard(props.item.family_edition_id, $event)"
          @contextmenu.prevent="openContext(props.item.family_edition_id, $event)"
        >
          <td class="pa-0">
            <div
              class="new-item-border"
              :class="{ 'd-none': true }"
            />
          </td>

          <td class="clickable">
            <span class="selectionText">{{ props.item.family_code }}</span>
          </td>

          <td
            :class="[
              { 'fw-600': $vuetify.breakpoint.smAndUp },
              { 'py-1 pr-0': $vuetify.breakpoint.xsOnly }
            ]"
            class="clickable"
          >
            <span class="selectionText">{{ fullName(props.item) }}</span>
            <div
              v-if="!desktopOnly"
              class="text-truncate"
            >
              <p class="ma-0">
                {{ fullStreet(props.item) }}
              </p>
              <p class="ma-0">
                {{ fullCity(props.item) }}
              </p>
            </div>
          </td>

          <td
            v-show="desktopOnly"
            class="clickable"
          >
            <div class="selectionText d-inline-block">
              <p class="ma-0">
                {{ fullStreet(props.item) }}
              </p>
              <p class="ma-0">
                {{ fullCity(props.item) }}
              </p>
            </div>
          </td>

          <td v-show="desktopOnly">
            <div
              v-if="
                isVolunteerAsigned(props.item) &&
                  hasPermissionVolunteerAssign &&
                  !isTurnedOff(props.item)
              "
            >
              <div v-if="isRefused(props.item.volunteer_refusal)">
                <p class="mb-0">
                  {{ $t('list.primary') }}:
                  <span :class="{ 'primary-rejected': !props.item.is_accepted }">{{
                    rejectingVolunteerName(props.item.volunteer_refusal)
                      ? rejectingVolunteerName(props.item.volunteer_refusal)
                      : $t('list.none')
                  }}
                  </span>
                </p>
                <p class="mb-0">
                  {{ $t('list.secondary') }}:
                  {{
                    volunteerName(props.item.secondary_volunteer)
                      ? volunteerName(props.item.secondary_volunteer)
                      : $t('list.none')
                  }}
                </p>
              </div>
              <a
                v-else
                class="pa-2"
                @click="doAction(2, props.item)"
              ><v-icon
                color="sz_violet"
                class="add-icon mr-2"
                small
              >add</v-icon>{{ $t('buttons.assign') }}</a>
            </div>
            <div
              v-else
              class="selectionText"
            >
              <p
                class="mb-0"
                :class="{ 'primary-volunteer-accept': !props.item.is_accepted }"
              >
                {{ $t('list.primary') }}:
                {{
                  volunteerName(props.item.primary_volunteer)
                    ? volunteerName(props.item.primary_volunteer)
                    : $t('list.none')
                }}
              </p>
              <p class="mb-0">
                {{ $t('list.secondary') }}:
                {{
                  volunteerName(props.item.secondary_volunteer)
                    ? volunteerName(props.item.secondary_volunteer)
                    : $t('list.none')
                }}
              </p>
            </div>
          </td>

          <td class="pl-1">
            <div v-if="desktopOnly">
              <v-layout
                v-if="displayAcceptButton(props.item)"
                class="text-xs-center"
              >
                <v-flex
                  class="mr-3"
                  @click="acceptFamily(props.item)"
                >
                  <v-layout>
                    <v-flex shrink>
                      <div class="fab-button bg_green">
                        <v-icon
                          color="#00BB62"
                          small
                        >
                          check
                        </v-icon>
                      </div>
                    </v-flex>
                    <v-flex
                      shrink
                      class="fab-link"
                    >
                      <a href="#">{{ $t('buttons.accept') }}</a>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex @click="refuseFamily(props.item)">
                  <v-layout>
                    <v-flex shrink>
                      <div class="fab-button bg_red">
                        <BaseIcon
                          color="#ED1C24"
                          width="10"
                          height="10"
                        >
                          <CloseIcon />
                        </BaseIcon>
                      </div>
                    </v-flex>
                    <v-flex
                      shrink
                      class="fab-link"
                    >
                      <a href="#">{{ $t('buttons.reject') }}</a>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout v-else>
                <familyStatus
                  :mobile="false"
                  :status="props.item.status"
                />
              </v-layout>
            </div>
            <div v-if="!desktopOnly">
              <v-layout
                v-if="displayAcceptButton(props.item)"
                class="text-xs-center"
              >
                <v-flex
                  class="mr-3"
                  @click="acceptFamily(props.item)"
                >
                  <v-layout
                    wrap
                    align-center
                    justify-center
                    row
                    fill-height
                  >
                    <v-flex xs12>
                      <div
                        class="fab-button bg_green"
                        style="margin: 0 auto"
                      >
                        <v-icon
                          small
                          color="#00BB62"
                        >
                          check
                        </v-icon>
                      </div>
                    </v-flex>
                    <v-flex
                      xs12
                      class="fab-link"
                    >
                      <a href="#">{{ $t('buttons.accept') }}</a>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex @click="refuseFamily(props.item)">
                  <v-layout wrap>
                    <v-flex xs12>
                      <div
                        class="fab-button bg_red"
                        style="margin: 0 auto"
                      >
                        <BaseIcon
                          color="#ED1C24"
                          width="10"
                          height="10"
                        >
                          <CloseIcon />
                        </BaseIcon>
                      </div>
                    </v-flex>
                    <v-flex
                      xs12
                      class="fab-link"
                    >
                      <a href="#">{{ $t('buttons.reject') }}</a>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout v-else>
                <v-flex>
                  <v-layout
                    align-center
                    column
                  >
                    <v-flex shrink>
                      <familyStatus
                        :mobile="true"
                        :status="props.item.status"
                      />
                    </v-flex>
                    <v-flex shrink>
                      <ActionMenu
                        :items="filteredActionMenu(props.item)"
                        :family-id="props.item.family_edition_id"
                        @clicked-item="doAction($event, props.item)"
                      />
                    </v-flex>
                    <v-flex
                      v-if="props.item.wio_struct_location_id === null"
                      class="pl-2 pb-1"
                      shrink
                    >
                      <v-tooltip bottom>
                        <template #activator="{ on }">
                          <v-icon
                            color="sz_red"
                            dark
                            v-on="on"
                          >
                            warning
                          </v-icon>
                        </template>
                        <span>{{ $t('message.family_without_rejon') }}</span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>
          </td>

          <td v-show="desktopOnly">
            <v-layout align-center>
              <v-flex class="none-growth">
                <ActionMenu
                  :items="filteredActionMenu(props.item)"
                  :family-id="props.item.family_edition_id"
                  @clicked-item="doAction($event, props.item)"
                />
              </v-flex>
              <v-flex
                v-if="props.item.wio_struct_location_id === null"
                class="none-growth"
              >
                <v-tooltip bottom>
                  <template #activator="{ on }">
                    <v-icon
                      color="sz_red"
                      dark
                      v-on="on"
                    >
                      warning
                    </v-icon>
                  </template>
                  <span>{{ $t('message.family_without_rejon') }}</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
          </td>
        </tr>
      </template>
      <template slot="no-data">
        <tr>
          <td colspan="9">
            <p
              v-show="!isLoading"
              class="text-xs-center pt-3"
            >
              {{ $t('message.error_families_list_empty') }}
            </p>
          </td>
        </tr>
      </template>
    </v-data-table>
    <manageVolunteersDialog
      :item="selectedItem"
      :show="isManageVolunteers"
      @show="isManageVolunteers = $event"
    />
    <CustomContextMenu
      :visible="contextData.visible"
      :event="contextData.event"
      :link-name="contextData.linkName"
      :id-param="contextData.id"
      @show="toggleContextMenu()"
    />
    <turnOffModal
      :visible="turnOffDialog"
      :family-id="familyId"
      :reasons-id="3"
      @close="turnOffDialog = false"
      @reload="$emit('sorting')"
    />
    <manageRegionDialog
      :show="manageRegion"
      :item="selectedItem"
      @show="manageRegion = $event"
    />
    <refuseReasonDialog
      :item="selectedItem"
      :show="isRefuseFamily"
      @remove-item="removeRefused(selectedItem)"
      @show="isRefuseFamily = $event"
    />
  </div>
</template>

<script>
import PhoneNumbersList from '@/components/widgets/PhoneNumbersList';
import ActionMenu from '../dataTable/ActionMenu';
import FamilyStatus from '../dataTable/FamilyStatus';
import filters from '@/constants/filters';
import BaseIcon from '@/icons/BaseIcon';
import ChangeIcon from '@/icons/ChangeIcon';
import SortIcon from '@/icons/SortIcon';
import manageVolunteersDialog from '@/components/widgets/dataTable/manageVolunteersDialog';
import refuseReasonDialog from '@/components/widgets/dataTable/refuseReasonDialog';
import CloseIcon from '@/icons/CloseIcon';
import PlusIcon from '@/icons/PlusIcon';
import CustomContextMenu from '@/components/widgets/CustomContextMenu';
import SortIconRevert from '@/icons/SortIconRevert';
import turnOffModal from '@/components/familyCard/TurnOffModal';
import manageRegionDialog from '@/components/widgets/dataTable/manageRegionDialog';
import Permissions from '@/constants/permissions';
import search from '@/mixins/search';

export default {
    name: 'NoVolunteerFamiliesTable',
    components: {
        manageRegionDialog,
        turnOffModal,
        CustomContextMenu,
        PlusIcon,
        CloseIcon,
        manageVolunteersDialog,
        FamilyStatus,
        ActionMenu,
        PhoneNumbersList,
        BaseIcon,
        ChangeIcon,
        SortIcon,
        refuseReasonDialog,
        SortIconRevert
    },
    filters: {
        ...filters
    },
    mixins: [search],
    props: ['items', 'headers', 'isLoading'],
    data () {
        return {
            selected: [],
            menuItems: [
                { id: 1, text: this.$t('list.actions.edit'), url: true },
                { id: 2, text: this.$t('list.actions.manage') },
                { id: 3, text: this.$t('list.actions.move') },
                { id: 4, text: this.$t('list.actions.disable') }
            ],
            manageRegion: false,
            isManageVolunteers: false,
            isRefuseFamily: false,
            selectedItem: null,
            selectedReason: null,
            contextData: {
                visible: false,
                event: null,
                linkName: 'family-card',
                id: null
            },
            hasPermissionVolunteerAssign: false,
            hasPermissionChangeWio: false,
            turnOffDialog: false
        };
    },
    computed: {
        desktopOnly () {
            return this.$vuetify.breakpoint.smAndUp;
        },
        filteredHeaders () {
            if (this.desktopOnly) {
                return this.headers;
            }
            return this.headers
                .filter((el) => {
                    return el.desktopOnly === false;
                })
                .sort((a, b) => {
                    if (b.text === 'ID' && a.text === this.$t('label.family')) {
                        return -1;
                    }
                    return 1;
                });
        },
        familyId () {
            return this.selectedItem ? this.selectedItem.family_edition_id : null;
        },
        featuresVisible () {
            return this.$store.getters.featuresVisible;
        }
    },
    created () {
        this.$store.dispatch('auth/hasPermission', Permissions.VOLUNTEER_ASSIGN).then((result) => {
            this.hasPermissionVolunteerAssign = result;
        });
        this.$store
            .dispatch('auth/hasPermission', Permissions.FAMILY_EDITION_CHANGE_WIO_STRUCT)
            .then((result) => {
                this.hasPermissionChangeWio = result;
            });
    },
    methods: {
        fullName (item) {
            if (item === null) return null;
            const _firstName = item.first_name !== null ? item.first_name : '';
            return _firstName + ' ' + item.last_name;
        },
        volunteerName (item) {
            if (item === null) return null;
            return item.full_name;
        },
        rejectingVolunteerName (refusals) {
            if (refusals.length > 0) {
                const lastRefusal = refusals[refusals.length - 1];
                return lastRefusal.volunteer.full_name;
            }
            return '';
        },
        fullStreet (item) {
            const street = item.street ? item.street : '';
            const _flat = item.flat_number !== null ? '/' + item.flat_number : '';
            return street + ' ' + item.building_number + _flat;
        },
        fullCity (item) {
            return this.$options.filters.postalCode(item.postal_code) + ' ' + item.city;
        },
        manageVolunteers () {
            this.isManageVolunteers = true;
        },
        doAction (actionID, item) {
            this.selectedItem = item;
            if (actionID === 1) {
                this.$router.push({ name: 'family-card', params: { id: item.family_edition_id } });
            }
            if (actionID === 2) {
                if (this.isRefused(item.volunteer_refusal) && item.primary_volunteer === null) {
                    this.$router.push({ name: 'family-card', params: { id: item.family_edition_id } });
                } else {
                    this.manageVolunteers();
                }
            }
            if (actionID === 4) {
                this.turnOffDialog = true;
            }
            if (actionID === 3) {
                this.manageRegion = true;
            }
        },
        isVolunteerAsigned (item) {
            return !(item.primary_volunteer || item.secondary_volunteer);
        },
        showCard (id, $event) {
            if (window.getSelection().toString() !== '') {
                return;
            }
            if (
                $event.target.localName === 'td' ||
        $event.target.localName === 'p' ||
        $event.target.localName === 'span'
            ) {
                this.$router.push({ name: 'family-card', params: { id } });
            }
        },
        isRefused (reason) {
            return reason !== null && reason.length >= 1;
        },
        isTurnedOff (item) {
            return item.status.family_edition_status_id === 3;
        },
        openContext (id, $event) {
            this.contextData.id = id;
            if (
                $event.target.localName === 'td' ||
        $event.target.localName === 'p' ||
        $event.target.localName === 'span'
            ) {
                this.contextData.visible = true;
                this.contextData.event = $event;
            }
        },
        toggleContextMenu (val) {
            this.contextData.visible = val;
        },
        filteredActionMenu (item) {
            let menuItems = this.menuItems;

            const noVolunteers = item.primary_volunteer == null && item.secondary_volunteer == null;

            if (this.hasPermissionChangeWio !== true || !noVolunteers) {
                menuItems = menuItems.filter((el) => {
                    return el.id !== 3;
                });
            }
            if (this.hasPermissionVolunteerAssign !== true) {
                menuItems = menuItems.filter((el) => {
                    return el.id !== 2;
                });
            }
            if (this.isTurnedOff(item)) {
                menuItems = menuItems.filter((el) => {
                    return el.id !== 2 && el.id !== 4 && el.id !== 3;
                });
            }
            if (!item.status.can_be_excluded) {
                menuItems = menuItems.filter((el) => {
                    return el.id !== 2 && el.id !== 4;
                });
            }
            return menuItems;
        },
        displayAcceptButton (item) {
            return (
                !item.is_accepted &&
        this.isPrimaryVolunteer(item) &&
        item.status.family_edition_status_id !== 3
            );
        },
        isPrimaryVolunteer (item) {
            return (
                item.primary_volunteer !== null &&
        item.primary_volunteer.id === this.$store.getters['auth/getUser'].id
            );
        },
        acceptFamily (item) {
            this.$store
                .dispatch('volunteers/acceptFamily', { id: item.family_edition_id })
                .then((data) => {
                    this.$emit('accept', item.family_edition_id);
                });
        },
        refuseFamily (item) {
            this.selectedItem = item;
            this.isRefuseFamily = true;
        },
        removeRefused (item) {
            this.$emit('reject', item.family_edition_id);
        }
    }
};
</script>

<style lang="scss" scoped>
@import './src/assets/css/_variables';
.primary-volunteer-accept {
  color: $sz_grey;
}
.primary-rejected {
  color: $sz_grey;
  text-decoration: line-through;
}
</style>
